module.exports = __webpack_public_path__ + "static/media/card-dontoi.cb6a2ac3.png";